module.exports = __webpack_public_path__ + "assets/img/service.09180b95.svg";